import { StatelessComponent, ReactNode } from 'react'
import * as styles from 'components/features/pfm/NetworthSummarySection/NetworthSummarySection.css'
import ChevronSvg from 'icons/chevron.svg'
import SvgIcon from 'components/atoms/SvgIcon'

type NetworthSummarySectionProps = {
  title: ReactNode
  onClick?: () => void
}

const NetworthSummarySection: StatelessComponent<NetworthSummarySectionProps> = ({ title, onClick, children }) => (
  <section className={ styles.section } onClick={ onClick }>
    <div className={ styles.title }>{ title }</div>
    <div className={ styles.body }>
      { children }
      { onClick && (
        <div className={ styles.switchButtonWrapper }>
          <div className={ styles.switchButton }>
            <SvgIcon src={ ChevronSvg } />
          </div>
        </div>
      )}
    </div>
  </section>
)

export default NetworthSummarySection
